export default function formatDateToMMDD(date = new Date()) {
    const month = date.toLocaleDateString('en-US', { month: '2-digit' });
    const day = date.toLocaleDateString('en-US', { day: '2-digit' });
    return `${month}/${day}`;
}
